// extracted by mini-css-extract-plugin
export default {"coverImg":"dashboard_coverImg__FC2zu"};